import SubProductModel from './sub-product'

export default class ProductModel {
  id

  code

  name

  price

  available

  thumbUrl

  options

salePrice

constructor (item = {}) {
  this.id = item.id
  this.name = item.name || ''
  this.code = item.code || ''
  this.price = item.price || 0
  this.available = item.available || 0
  this.thumbUrl = item.thumbUrl || item.pictureUrl
  this.salePrice = item.price || 0
  this.options = [new SubProductModel({
    id: item.id,
    name: 'main',
    fullName: item.name,
    code: item.code || '',
    price: item.price || 0,
    available: item.available || 0,
    salePrice: item.price || 0
  })]
}
}
